module.exports = __webpack_public_path__ + "img/Icon__Torture.4d137930.svg";